// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Plaintext.less';

/**
 * Plaintext component.
 */
const Plaintext = ({ baseClassName, className, children }) => (
    <pre className={classNames(baseClassName, className)}>
        {children}
    </pre>
);
Plaintext.propTypes = {
    /**
     * Content of the Plaintext
     */
    children: PropTypes.string.isRequired,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Plaintext.defaultProps = {
    className: null,
    baseClassName: `${CLS_PREFIX}plaintext`,
};

export default Plaintext;



// WEBPACK FOOTER //
// ./components/Plaintext/Plaintext.js